// extracted by mini-css-extract-plugin
export default {"container":"yhViX","header":"r0TCk","main":"fGOal","error":"Oj8Ho"};